import React, { useContext } from 'react';
import StringInput from '../components/StringInput';
import TextareaInput from '../components/TextareaInput';
import DatepickerInput from '../components/DatepickerInput';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { styled } from '@mui/system';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MetadataContext } from '../contexts/MetadataContext';


// Color definitions
const blue = {
  100: '#DAECFF',
  200: '#80BFFF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

// Styled components
const StyledContainer = styled('div')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  border-radius: 8px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
  };
  padding: 16px;
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px; /* Add space between components */
`
);

const StyledInput = styled(StringInput)(
  ({ theme }) => `
  margin-bottom: 16px;
`
);

const StyledDatepickerInput = styled(DatepickerInput)(
  ({ theme }) => `
  margin-bottom: 16px;
`
);

const StyledTextareaInput = styled(TextareaInput)(
  ({ theme }) => `
  margin-bottom: 16px;
`
);



const ConfigPage = () => {
  const { metadata, updateMetadata } = useContext(MetadataContext);

  const handleInputChange = (field, value) => {
    updateMetadata({
      ...metadata,
      [field]: value,
    });
  };

  // Convert Firebase timestamp to JavaScript Date
  const convertFirebaseTimestampToDate = (timestamp) => {
    if (timestamp && timestamp.seconds) {
      return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
    }
    return null;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledContainer>
        <h1>Config Page - Changes are saved instantly</h1>
        <StyledInput
          label="ChatGPT API Key"
          value={metadata.OPENAI_API_KEY}
          onChange={(e) => handleInputChange('OPENAI_API_KEY', e.target.value)}
          type="text"
        />
        <StyledInput
          label="Number of articles"
          value={metadata.maxArticles}
          onChange={(e) => handleInputChange('maxArticles', e.target.value)}
          type="number"
        />
        <StyledDatepickerInput
          label="LastFetched Date"
          value={convertFirebaseTimestampToDate(metadata.lastFetch)}
          onChange={(date) => handleInputChange('lastFetch', date)}
        />
        <StyledTextareaInput
          label="Prompt for newsletter"
          value={metadata.prompt_newsletter}
          onChange={(e) => handleInputChange('prompt_newsletter', e.target.value)}
          rows={10}
        />
        <StyledTextareaInput
          label="Prompt for hot topics"
          value={metadata.prompt_hotTopics}
          onChange={(e) => handleInputChange('prompt_hotTopics', e.target.value)}
          rows={10}
        />
      </StyledContainer>
    </LocalizationProvider>
  );
};

export default ConfigPage;